jQuery(($) => {

    if ($('.m-filters')[0]) {
        $('.m-filters__button').click(function(){
            $(this).parent().toggleClass('m-filters--open');
            $(this).toggleClass('m-filters__button--toggled');
        })
    }
});